import { createContext } from 'react';

/**
 * Used to control where data areas appear and how photos are treated
 */
export var PropertyCardContext = /*#__PURE__*/createContext({});
export var PropertyCardProvider = PropertyCardContext.Provider;